import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup, ValidatorFn, AbstractControl, FormControl, NgForm } from '@angular/forms';
import { CommonService } from '../../services/common.service';

import {  Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
@Component({
  selector: 'app-frgtpwd',
  templateUrl: './frgtpwd.component.html',
  styleUrls: ['./frgtpwd.component.css']
})
export class FrgtpwdComponent implements OnInit {
forgotpassform: any;
flag: Number;
flag1: number
otp: Number;
  constructor(public form: FormBuilder, private commonService: CommonService,
    @Inject(PLATFORM_ID) private platformId: Object) {
    this.flag1 = 0;
    this.forgotpassform = this.form.group({
  
    'email': new FormControl('', [Validators.required,
      Validators.pattern(/^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i)]),
    });
   }

  ngOnInit() {
  }


  postForgotpass(form: NgForm){

    this.commonService.postForgotpass(this.forgotpassform.email)
    .subscribe((x)=>{
      this.flag1 = 1;
    },(err)=>{
      if (err.status === 501) {
        this.flag1 = 2;
      }
    });
  }

  equalto(field_name): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} => {
    const input = control.value;
    const  isValid = control.root.value[field_name] === input
// Add a comment to this line
    if (!isValid) {
      return { 'equalTo': {isValid} }
    } else {
      return null;
    }
  };
  }

genotp() {
  if (isPlatformBrowser(this.platformId)) {
  this.otp = this.getRandomArbitrary(1000, 9000)
  this.flag = 1;
  localStorage.setItem('otpdata',JSON.stringify({otp:this.otp}));
  }
}

  getRandomArbitrary(min, max) {
  var num = min + Math.random() * max;
  return Math.trunc(num);
    
}

}
